import { Link } from "react-router-dom";
import { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <header className="w-full bg-white px-4 md:px-8 py-4 flex items-center justify-between relative">
      {/* Logo */}
      <Link to="/" className="flex items-center gap-3">
        <img
          src="/logo1.png"
          alt="Billion Deals Admin"
          className="h-10 md:h-12 w-auto object-contain"
        />
        <span className="text-xl font-bold text-gray-800 hidden md:inline">
          Billion Deals
        </span>
      </Link>

      {/* Hamburger for mobile */}
      <button
        className="md:hidden text-gray-700"
        onClick={toggleMenu}
        aria-label="Toggle Menu"
      >
        {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
      </button>

      {/* Navigation */}
      <nav
        className={`md:flex md:items-center md:gap-12 ${
          isOpen
            ? "absolute top-full right-0 w-56 bg-white shadow-lg flex flex-col items-start py-4 px-4 rounded-md md:static md:flex-row md:w-auto md:shadow-none"
            : "hidden md:flex"
        }`}
      >
        {["Home", "About", "Services", "Contact"].map((item) => (
          <Link
            key={item}
            to={item === "Home" ? "/" : `/${item.toLowerCase()}`}
            className="relative block py-2 md:py-0 px-2 text-xl font-semibold text-gray-700 transition-all duration-300 hover:text-gray-900 hover:after:w-full after:content-[''] after:absolute after:-bottom-1 after:left-0 after:h-1 after:w-0 after:bg-gradient-to-r after:from-gray-800 after:to-gray-50 after:transition-all after:duration-300"
            onClick={() => setIsOpen(false)}
          >
            {item}
          </Link>
        ))}
      </nav>
    </header>
  );
}

export default Header;
